import {HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {toObservable} from '@angular/core/rxjs-interop';
import {RootStore} from '@scalified-monorepo/ng-shared/ngrx';
import {CommonHeaders} from '@scalified-monorepo/shared';
import {combineLatest, Observable, throwError} from 'rxjs';
import {filter, switchMap, take, timeout} from 'rxjs/operators';

const CLIENT_ID_TIMEOUT_MS = 10000; // 10 seconds timeout

export function commandMetadataInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  // Only apply to account and auth command endpoints
  if (!req.url.includes('/account/command') && !req.url.includes('/auth/command')) {
    return next(req);
  }

  const rootStore = inject(RootStore);

  return combineLatest([
    toObservable(rootStore.clientId).pipe(
      filter(clientId => !!clientId), // Wait until clientId is non-empty
      take(1),
      timeout({
        first: CLIENT_ID_TIMEOUT_MS,
        with: () =>
          throwError(() => new Error('Client initialization timeout. Please refresh the page and try again.')),
      })
    ),
    toObservable(rootStore.countryCode).pipe(take(1)),
  ]).pipe(
    switchMap(([clientId, country]) => {
      const headers: Record<string, string> = {};
      if (clientId) headers[CommonHeaders.ClientId] = clientId;
      if (country) headers[CommonHeaders.Country] = country;

      if (Object.keys(headers).length > 0) {
        return next(req.clone({setHeaders: headers}));
      }
      return next(req);
    })
  );
}
